/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTrendingUp = createReactComponent("trending-up", "IconTrendingUp", [
  ["path", { d: "M3 17l6 -6l4 4l8 -8", key: "svg-0" }],
  ["path", { d: "M14 7l7 0l0 7", key: "svg-1" }]
]);

export { IconTrendingUp as default };
//# sourceMappingURL=IconTrendingUp.js.map
